import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

import {firstValueFrom} from "rxjs";
import {User, UserService} from "../../services/user.service";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { MatButtonModule } from '@angular/material/button';
import { AvatarComponent } from '../avatar/avatar.component';
import { MatMenuModule } from '@angular/material/menu';
import { NgIf } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

import { getCurrentUser, signOut, fetchAuthSession } from 'aws-amplify/auth';
import { BreakpointObserver } from '@angular/cdk/layout';


export type Mode = 'Student' | 'Teacher' ;

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    standalone: true,
    imports: [FaIconComponent, NgIf, MatMenuModule, AvatarComponent, MatButtonModule, RouterLink]
})
export class NavbarComponent implements OnInit {

  authenticating: boolean = true ;
  user?: User ;

  @Input()
  showBrand: boolean = true ;

  @Input()
  mode: Mode = 'Student' ;

  @Output()
  modeChange: EventEmitter<Mode> = new EventEmitter<Mode>();

  isMobile: boolean = false;

  constructor(
    private users: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private observer: BreakpointObserver
  ) { }

  async ngOnInit() {

    this.observer.observe(['(max-width: 800px)']).subscribe((screenSize) => {
      if(screenSize.matches){
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    });

    this.authenticating = true ;

    

    try {
      const u = await getCurrentUser() ;
      console.log("user", u) ;

      const s = await fetchAuthSession() ;
      console.log("session", s) ;

      this.user = await firstValueFrom(this.users.getUser());
    }
    catch (e) {
      // do nothing
    }

    this.authenticating = false ;

    
  }

  get canTeach(): boolean {
    return this.user?.type == 'SUPERUSER' || this.user?.type == 'TEACHER' ;
  }


  async signOut() {

    const result = signOut() ;
    console.log(result);
    this.users.clearUser();
    this.user = undefined;
    await this.router.navigate(['/']) ;
  }

  async setMode(mode: Mode) {

    //if (mode == this.mode) {
    //  return ;
    //}

    this.mode = mode ;
    this.modeChange.emit(mode);

    switch (this.mode) {
      case "Student":
        await this.router.navigate(['/']) ;
        break ;
      case "Teacher":
        await this.router.navigate(['/admin']) ;
        break ;
    }
  }

  async editProfile() {
    console.log(this.router.url) ;
    await this.router.navigate(['/edit-profile'], {queryParams: {returnUrl:this.router.url}}) ;

    //routerLink="/edit-profile"

  }
}
